// Design tokens for typography and fills

export const fontTokens = {
  // Home / Work page type scale (owner 2026-10-25): values 13.5px semibold, labels
  // 12px semibold, card titles 15px extra bold, section titles 17px extra bold.
  body2Medium: "text-[13.5px] leading-[20px] font-semibold text-left align-top",
  body2Regular: "text-[12px] leading-[18px] font-semibold text-left align-top",
  cardSub: "text-[13px] leading-[19px] font-normal text-left align-top",
  subtitle3: "text-[15px] leading-[22px] font-extrabold text-left align-top",
  subtitle2: "text-[17px] leading-[24px] font-extrabold text-left align-top",
};

export const colorTokens = {
  bodyprimary: "text-[#1F2433] text-opacity-100",
  bodytertiary: "text-[#5F758F] text-opacity-100",
  settingstitle: "text-[#2B333C] text-opacity-100",
};

export const buttonTokens = {
  whiteButton: "transitions-all h-10 rounded-lg border border-[#C8D2DE] bg-white px-4 text-sm font-medium text-[#253747] duration-300 hover:shadow-settings-grey",
  purpleButton: "transitions-all h-10 rounded-lg border border-[#6938EF] bg-[#6938EF] px-4 text-sm font-medium text-white duration-300 hover:shadow-settings-purple"
};